import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_URL, BASE_LEAVE_URL } from '../apiConfig';

const fetchCompOffHistory = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/comp-off/enquiry`,
    payload,
  );
  return response;
};

const fetchCompOffDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/comp-off`,
    payload,
  );
  return response;
};

const fetchCompOffByTransNo = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/comp-off/trans`,
    payload,
  );
  return response;
};

const applyCompOff = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_LEAVE_URL}/comp-off/apply`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response;
};

export {
  fetchCompOffDetails,
  fetchCompOffHistory,
  fetchCompOffByTransNo,
  applyCompOff,
};
